import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { PackageFilterService } from '../../shared/filter/package-filter.service';
import { AppState } from '../../../store';
import { ReactiveFormsModule, FormGroup, FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { selectPackageTableQuery } from '../../../store/package-table/package-table.state';
import { FilterAssist } from '../../../models/filter-assist';
import { debounceTime, filter, map, mergeMap, switchMap } from 'rxjs/operators';
import { packageTableAddAssist, packageTableRemoveAssist } from '../../../store/package-table/package-table.actions';
import { Store } from '@ngrx/store';
import { MatOption } from '@angular/material/core';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { IconComponent } from '../../shared/icon/icon.component';
import { AsyncPipe } from '@angular/common';
import { MatChipGrid, MatChipRow, MatChipRemove, MatChipInput } from '@angular/material/chips';
import { MatFormField } from '@angular/material/form-field';
import { PackageQuery } from '../../../models/package-query';

@Component({
    selector: 'app-packages-table-filter',
    templateUrl: './packages-table-filter.component.html',
    styleUrls: [ './packages-table-filter.component.scss' ],
    imports: [ReactiveFormsModule, MatFormField, MatChipGrid, MatChipRow, MatChipRemove, IconComponent, MatInput, MatChipInput, MatAutocompleteTrigger, MatAutocomplete, MatOption, AsyncPipe]
})
export class PackagesTableFilterComponent implements OnInit {

    @ViewChild('termsInput') termsInput: ElementRef<HTMLInputElement>;

    public searchForm = new FormGroup({
        terms: new FormControl('')
    });

    constructor(private packageFilterService: PackageFilterService, private store: Store<AppState>) {
    }

    query$: Observable<PackageQuery> = this.store.select(selectPackageTableQuery);
    activeAssists$: Observable<FilterAssist[]> = this.query$.pipe(
        switchMap((query) => this.packageFilterService.activeAssists(query))
    );
    offeredAssists$: Observable<FilterAssist[]> = this.searchForm.valueChanges.pipe(
        debounceTime(200),
        map(form => form.terms),
        filter(terms => typeof terms === 'string'),
        mergeMap(terms => this.packageFilterService.autocompleteTerms(terms))
    );

    ngOnInit(): void {
    }

    onAssistSelection(assist: FilterAssist): void {
        this.store.dispatch(packageTableAddAssist({ id: assist.id, parameter: assist.parameter }));
        this.termsInput.nativeElement.value = '';
        this.searchForm.get('terms').setValue('');
    }

    onRemoveAssist(id: string): void {
        this.store.dispatch(packageTableRemoveAssist({ id }));
    }

}
